<script setup lang="ts">
import VIcon from "../Icon/VIcon.vue";
import { useActiveSidebar } from "./useActiveSidebar";

// On phones the page sidebar is off screen; this bar is the way back into it.
const { active } = useActiveSidebar();
</script>

<template>
  <div
    v-if="active"
    class="md:hidden sidebar-mobile-bar flex items-center gap-1 shrink-0 h-12 px-2 bg-gray-50 dark:bg-dark-900 border-b border-solid border-gray-200 dark:border-dark-700 text-gray-800 dark:text-gray-100 box-content pt-[env(safe-area-inset-top)]"
  >
    <button
      type="button"
      class="flex items-center justify-center w-10 h-10 rounded-md text-lg text-gray-600 dark:text-gray-300 active:bg-gray-200 dark:active:bg-dark-800"
      :aria-label="active.title()"
      @click="active.open()"
    >
      <VIcon name="menu" />
    </button>
    <div class="min-w-0 truncate font-bold text-lg">
      {{ active.title() }}
    </div>
  </div>
</template>
